/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ticketsaddfirst2Inputs */

const en_ticketsaddfirst2 = /** @type {(inputs: Ticketsaddfirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add the first ticket type`)
};

const de_ticketsaddfirst2 = /** @type {(inputs: Ticketsaddfirst2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erste Ticketart anlegen`)
};

/**
* | output |
* | --- |
* | "Add the first ticket type" |
*
* @param {Ticketsaddfirst2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const ticketsaddfirst2 = /** @type {((inputs?: Ticketsaddfirst2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ticketsaddfirst2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ticketsaddfirst2(inputs)
	return de_ticketsaddfirst2(inputs)
});
export { ticketsaddfirst2 as "ticketsAddFirst" }